import React from "react";
import Text from "../text/Text";
import { ActionButton } from "../../global/Modals/ActionModal/components/ActionButton";
import { ActionIcon } from "../../global/Modals/ActionModal/components/ActionIcon";
import { useTheme } from "@mui/material";
import { tokens } from "../../../theme";

const DropdownButton = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <ActionButton 
            sx={{
                background:theme.palette.mode === "dark" ? colors.grey[300]  : "#fff",
                "&:hover" : {
                    transition:"250ms",
                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.bg["tertiary"],
                    boxShadow:"none"
                },

            }} 
            disabled={props.disabled ?? false}  
            onClick={props.onClick}
        >
            <ActionIcon color={props.actionIconColor ?? null}>
                {React.cloneElement(props.icon, {fontSize:"small"})}
                {/* <SettingsOutlinedIcon fontSize="small" /> */}
            </ActionIcon>
            <Text medium>
                {props.text}
            </Text>
        </ActionButton>
    )
}

export default DropdownButton;